// src/components/Contact/Contact.jsx
import { useState } from 'react'
import style from './Contact.module.css'
import LocationIcon2 from '../../../assets/svgs/Location2'
import EnvelopeIcon2 from '../../../assets/svgs/Envelope2'
import MapDisplay from '../../../utils/GoogleMap'
import useWindowHeight from '../../../hooks/useWindowHeight'
import useWindowWidth from '../../../hooks/useWindowWidth'

const Contact = () => {
  const innerWidth = useWindowWidth()
  const innerHeight = useWindowHeight()
  const url = process.env.REACT_APP_API_URL || ''
  // form state
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })
  const [status, setStatus] = useState(null) // null | 'sending' | 'success' | 'error'

  const handleChange = e => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setStatus('sending')

    try {
      const res = await fetch(`${url}/users/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      })
      const data = await res.json()

      if (res.ok) {
        setStatus('success')
        setForm({ name: '', email: '', subject: '', message: '' })
      } else {
        console.error('Server error:', data)
        setStatus('error')
      }
    } catch (err) {
      console.error('Network error:', err)
      setStatus('error')
    }
  }

  return (
    <div className={style.mainContainer} id="contact">
      <p className={style.contactTitle}>Contact</p>
      <div className={style.container}>
        <MapDisplay
          height={innerWidth < 400 ? '280px' : innerHeight > 560 ? '150px' : ''}
          width="100%"
        />
        <div className={style.formContainer}>
          <div className={style.left}>
            <div className={style.contact}>
              <div className={style.iconContainer}><LocationIcon2/></div>
              <div className={style.contactInfo}>
                <p className={style.text}>Location</p>
                <p className={style.subText}>Forskningsringen 88, 174 62 Sundbyberg</p>
              </div>
            </div>
            <div className={style.contact}>
              <div className={style.iconContainer}><EnvelopeIcon2/></div>
              <div className={style.contactInfo}>
                <p className={style.text}>Mail</p>
                <p className={style.subText}>adchimp.ai@gmail.com</p>
              </div>
            </div>
          </div>
          <div className={style.right}>
            <form onSubmit={handleSubmit}>
              <div className={style.inputs}>
                <div className={style.inputDiv}>
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className={style.names}
                    placeholder="Name"
                    required
                  />
                </div>
                <div className={style.inputDiv}>
                  <input
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    className={style.names}
                    placeholder="Email"
                    required
                  />
                </div>
              </div>
              <div className={style.inputDiv}>
                <input
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  className={style.input}
                  placeholder="Subject"
                  required
                />
              </div>
              <div className={style.inputDiv}>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  className={style.inputMessage}
                  placeholder="Message"
                  required
                  rows={4}
                />
              </div>
              <div className={style.buttonContainer}>
                <button
                  type="submit"
                  className={style.button}
                  disabled={status === 'sending'}
                >
                  {status === 'sending' ? 'Sending…' : 'Send Message'}
                </button>
              </div>
              {status === 'success' && <p>✅ Message sent!</p>}
              {status === 'error' && <p>❌ Something went wrong.</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
